module.exports = __webpack_public_path__ + "535bb9f58148b0cc17b8929884bbc3f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/train/view/home/images/7.png
// module id = 183
// module chunks = 1